// extracted by mini-css-extract-plugin
export default {"container":"NoteItem_container__xZ1lS","edit":"NoteItem_edit__b6xzR","content":"NoteItem_content__mCKAp","updatedBy":"NoteItem_updatedBy__Fcq0Q"};